const Loading = () => {
    return (
      <div className='dots-container'>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
      </div>
    );
  };
  
  export default Loading;